import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftacademicComponent } from './simple-icons-microsoftacademic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftacademicComponent ],
    exports:      [ SimpleIconsMicrosoftacademicComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftacademicModule {}
